import { useHref, useLinkClickHandler, type To } from "react-router";

/**
 * @description Turns any component accepting `href` and `onClick` (`Btn`, a
 * plain element) into a real link: middle click, ctrl+click, "copy link
 * address" and the browser status bar keep working, while a plain click still
 * navigates client-side.
 */
export const useInstagramSearchLink = (to: To) => {
  const href = useHref(to);
  const onClick = useLinkClickHandler<Element>(to);

  return {
    href,
    onClick,
  };
};
